import { useId } from 'react'

// Input primitif — DESIGN-GUIDE (typo/spacing) + a11y (label lie via htmlFor/id).
// Tokens : bg-input / border-input-border / text-ink -> s'adapte au theme.

export default function Input({ label, id, className = '', containerClassName = '', ...props }) {
  const autoId = useId()
  const inputId = id || autoId
  return (
    <div className={containerClassName}>
      {label && (
        <label htmlFor={inputId} className="block text-sm font-medium text-ink mb-1.5">
          {label}
        </label>
      )}
      <input
        id={inputId}
        className={`w-full px-3.5 py-3 rounded-xl text-sm bg-input border border-input-border text-ink placeholder:text-ink/40 focus:outline-none focus:border-primary transition ${className}`.trim()}
        {...props}
      />
    </div>
  )
}
